/**
 * toolsStore — Zustand store that fetches and caches the tool registry
 * from `GET /api/tools` (auth required). Used by rich-hover tooltips on
 * canvas nodes and by the Lumière workflow agent UI.
 */
import { create } from 'zustand';
import agentService from '../services/agentService';

export const useToolsStore = create((set, get) => ({
  tools: [],           // array of ToolDescriptor
  toolsById: {},       // { [id]: descriptor }
  loading: false,
  error: null,
  loadedAt: null,

  /**
   * Fetch the catalog once. Subsequent calls are a no-op unless `force`.
   */
  fetchTools: async ({ force = false } = {}) => {
    const { loading, loadedAt } = get();
    if (loading) return;
    if (loadedAt && !force) return;

    set({ loading: true, error: null });
    try {
      const res = await agentService.listTools();
      const tools = res?.tools || [];
      const toolsById = {};
      for (const t of tools) toolsById[t.id] = t;
      set({ tools, toolsById, loading: false, loadedAt: Date.now() });
    } catch (err) {
      set({ loading: false, error: err?.message || 'Failed to load tools' });
    }
  },

  getTool: (id) => get().toolsById[id] || null,
}));

export default useToolsStore;
